import React from 'react';

// Format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount || 0);
};

export default function ExpenseReportFooter({ report }) {
  // Count expenses by category
  const categoryBreakdown = {};
  report.expenses?.forEach(exp => {
    const cat = exp.category || 'Other';
    categoryBreakdown[cat] = (categoryBreakdown[cat] || 0) + (exp.amount || 0);
  });

  return (
    <div className="px-6 pb-4 pt-2">
      {/* Category Breakdown */}
      {Object.keys(categoryBreakdown).length > 0 && (
        <div className="mb-4 p-3 bg-slate-50 rounded">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-2">Category Breakdown</p>
          <div className="grid grid-cols-3 gap-4 text-sm">
            {Object.entries(categoryBreakdown).map(([category, amount]) => (
              <div key={category}>
                <p className="text-slate-500 text-[10px]">{category}</p>
                <p className="font-medium text-slate-700">{formatCurrency(amount)}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Notes */}
      {report.notes && (
        <div className="mb-4 p-3 bg-slate-50 rounded">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Notes</p>
          <p className="text-sm text-slate-600">{report.notes}</p>
        </div>
      )}

      {/* Approval Info */}
      {report.status === 'Approved' && report.approved_by && (
        <div className="mb-4 p-3 bg-green-50 rounded border border-green-200">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-green-600 mb-1">Approved</p>
          <p className="text-sm text-green-700">
            By {report.approved_by} on {report.approved_at ? new Date(report.approved_at).toLocaleDateString() : 'N/A'}
          </p>
        </div>
      )}

      {/* Payment Info */}
      {report.status === 'Paid' && (
        <div className="mb-4 p-3 bg-emerald-50 rounded border border-emerald-200">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-emerald-600 mb-1">Payment Recorded</p>
          <p className="text-sm text-emerald-700">
            {report.payment_method && `Method: ${report.payment_method}`}
            {report.paid_at && ` • ${new Date(report.paid_at).toLocaleDateString()}`}
          </p>
        </div>
      )}
      
      {/* Signature Section */}
      <div className="border-t border-slate-200 pt-4">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-3">Authorization</p>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border-b border-slate-400 h-6 mb-1" />
            <p className="text-[10px] text-slate-500">Employee Signature & Date</p>
          </div>
          <div>
            <div className="border-b border-slate-400 h-6 mb-1" />
            <p className="text-[10px] text-slate-500">Manager Signature & Date</p>
          </div>
        </div>
      </div>
      
      {/* Footer bar */}
      <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between text-[10px] text-slate-400">
        <span>Center Line Locating, LLC · Charlotte, NC · (704) 315-5820</span>
        <span>Expense Report #{report.report_number || report.id}</span>
      </div>
    </div>
  );
}
